<template>

    <trax-ui-ajax-form-in-modal :id="id" :toastr-id="toastrId" :endpoint="endpoint" 
        :props="props" :titles="titles" :form="form" :bus="bus" icons="1">

        <trax-ui-select icon="list_alt" v-model="form.type" :options="program_types_select" 
            v-show="!form.id">
        </trax-ui-select>

        <trax-ui-input type="text" icon="text_fields" :placeholder="lang.polaris.form.name"
            v-model="form.name" :error="errors.name" required="1">
        </trax-ui-input>

        <trax-ui-input type="text" icon="text_fields" rows="3" :placeholder="lang.polaris.form.description"
            v-model="form.description" :error="errors.description">
        </trax-ui-input>

        <trax-ui-select icon="cached" v-model="form.status" :options="status_select">
        </trax-ui-select>

        <trax-ui-select icon="playlist_add_check" v-model="form.gc_index_id" 
            :options="general_criterias_indexes_select" :placeholder="lang.polaris.common.general_criterias"
            v-show="generalCriteriasIndexAvailable">
        </trax-ui-select>

        <p class="text-danger mb-0" style="padding-left: 52px;">
            <small>{{ lang.polaris.common.competency_index_change_warning }}</small>
        </p>

        <trax-ui-input icon="playlist_add_check" :value="generalCriteriasIndexName" disabled="1"
            :placeholder="lang.polaris.common.general_criterias" v-show="!generalCriteriasIndexAvailable">
        </trax-ui-input>

        <trax-ui-select icon="playlist_add_check" v-model="form.bi_index_id" 
            :options="behavioural_indicators_indexes_select" :placeholder="lang.polaris.common.behavioural_indicators"
            v-show="behaviouralIndicatorsIndexAvailable">
        </trax-ui-select>

        <p class="text-danger mb-0" style="padding-left: 52px;">
            <small>{{ lang.polaris.common.competency_index_change_warning }}</small>
        </p>

        <trax-ui-input icon="playlist_add_check" :value="behaviouralIndicatorsIndexName" disabled="1"
            :placeholder="lang.polaris.common.behavioural_indicators" v-show="!behaviouralIndicatorsIndexAvailable">
        </trax-ui-input>

        <trax-ui-select icon="check" v-model="form.rating_scale_id" :options="rating_scales_select"
            :placeholder="lang.polaris.training.rating_scale"
        >
        </trax-ui-select>

        <trax-ui-select icon="insert_photo" v-model="form.meta.background" :options="backgrounds_select" v-show="form.id">
        </trax-ui-select>

    </trax-ui-ajax-form-in-modal>
    
</template>

<script>
    export default {

        props: ['bus', 'id', 'toastrId', 'endpoint'],
    
        data: function() {
            return {
                lang: lang,
                form: {
                    meta: {}
                },
                data: {},
                errors: {},
                status_select: data.status_select,
                program_types_select: data.program_types_select,
                rating_scales_select: data.rating_scales_select,
                backgrounds_select: data.backgrounds_select,
                general_criterias_indexes_select: data.general_criterias_indexes_select,
                behavioural_indicators_indexes_select: data.behavioural_indicators_indexes_select,
                props: {
                    id: { source:'id' },
                    name: { source:'name' },
                    description: { source:'description' },
                    status: { source:'status', default:'draft' },
                    type: { source:'type', default: data.program_type_default },
                    meta: { source: this.meta },
                    bi_index_id: { source:'bi_index_id' },
                    gc_index_id: { source:'gc_index_id' },
                    rating_scale_id: { source:'rating_scale_id' },
                },
                titles: {
                    new: lang.polaris.training.new_program,
                    update: lang.polaris.training.program_update
                },
                native_general_criterias_index: null,
                native_behavioural_indicators_index: null,
            }
        },

        computed: {

            generalCriteriasIndexAvailable: function() {
                var value = this.form.gc_index_id;
                if (!value) return true;
                for (var index in this.general_criterias_indexes_select) {
                    if (this.general_criterias_indexes_select[index].value == value) return true;
                }
                return false;
            },

            behaviouralIndicatorsIndexAvailable: function() {
                var value = this.form.bi_index_id;
                if (!value) return true;
                for (var index in this.behavioural_indicators_indexes_select) {
                    if (this.behavioural_indicators_indexes_select[index].value == value) return true;
                }
                return false;
            },

            generalCriteriasIndexName: function() {
                for (var index in this.data.competency_indexes) {
                    if (this.data.competency_indexes[index].id == this.form.gc_index_id) {
                        return this.data.competency_indexes[index].name;
                    }
                }
                return '';
            },

            behaviouralIndicatorsIndexName: function() {
                for (var index in this.data.competency_indexes) {
                    if (this.data.competency_indexes[index].id == this.form.bi_index_id) {
                        return this.data.competency_indexes[index].name;
                    }
                }
                return '';
            }
        },

        created: function() {
            var that = this;

            this.bus.$on(that.id+'-errors', function(errors) {
                that.errors = errors;
            });

            this.bus.$on(that.id+'-data', function(data, nativeData) {
                that.form = data;
                that.data = nativeData;
                that.native_general_criterias_index = that.data.gc_index_id;
                that.native_behavioural_indicators_index = that.data.bi_index_id;
            });
        },

        methods: {
            
            meta(data) {
                return Array.isArray(data.meta) ? {} : data.meta
            }
        }
    }
</script>
